const DISMISS_KEY = 'nmr_dismissed_weather_alerts_v1';

export function loadDismissedWeatherAlertIds() {
  try {
    const raw = sessionStorage.getItem(DISMISS_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch {
    return new Set();
  }
}

export function dismissWeatherAlert(alertId) {
  if (!alertId) return;
  const dismissed = loadDismissedWeatherAlertIds();
  dismissed.add(alertId);
  try {
    sessionStorage.setItem(DISMISS_KEY, JSON.stringify([...dismissed]));
  } catch {
    // ignore quota errors
  }
}

export function filterActiveWeatherAlerts(alerts, dismissedIds) {
  return alerts.filter((alert) => {
    const id = alert?.properties?.id;
    return id && !dismissedIds.has(id);
  });
}